// extracted by mini-css-extract-plugin
export default {"container":"ProductDetails_container__zL0aE","content":"ProductDetails_content__3Trrv","loading":"ProductDetails_loading__Hsn4d"};